const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg20210629PridictDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 12407 1926",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1501.68,-12690.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.835188,0,0,0.835188,534.579,2251.81)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.523166,0,0,0.523166,-315.396,10093.9)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4559.48,
    cy: 6339.84,
    r: 1638.39,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "209.79px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.523166,0,0,0.494432,-528.352,9995.49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3949.08,8305.52L3949.08,8989.39",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "212.02px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.523166,0,0,0.501529,-528.442,9973.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5984.33,8214.33L5984.33,8905.93C5984.33,8905.93 5154.15,9410.67 3949.26,8905.93",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "214.17px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.523166,0,0,0.523166,-528.352,9737.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3949.08,8989.39L3590.78,9213.72",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "206.28px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.523166,0,0,0.523166,-528.352,9737.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5984.33,8989.39L6285.61,9213.72C6285.61,9213.72 5922.92,9516.01 5257.09,9570.98C4824.29,9606.71 4263.4,9537.94 3590.78,9213.72",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "209.79px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.523166,0,0,0.523166,-528.352,9737.19)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3483.55,475.645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M568.499,7021.65L829.012,7021.65L829.012,6468.03C829.012,6468.03 702.849,6351.25 829.012,6225.09",
    style: {
      fill: "none",
      stroke: "rgb(50,108,152)",
      strokeWidth: "119.01px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3483.55,475.645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M829.012,6225.09L829.012,6020.21C762.139,6007.49 734.204,5958.08 731.781,5902.39C729.449,5848.84 764.702,5792.11 829.012,5769.31C847.7,5762.69 868.841,5758.93 892.227,5758.95C997.124,5759.04 1047.14,5825.99 1048.57,5893.81C1050.04,5963.55 1014.85,6009.24 949.024,6020.21L949.024,6225.09C949.024,6225.09 1094.14,6314.72 949.024,6472.65",
    style: {
      fill: "none",
      stroke: "rgb(50,108,152)",
      strokeWidth: "119.01px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3483.55,475.645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M949.024,6472.65L949.024,7021.65L1303.29,7021.65",
    style: {
      fill: "none",
      stroke: "rgb(50,108,152)",
      strokeWidth: "119.01px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3483.55,475.645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1303.29,7021.65L1303.29,6667.31",
    style: {
      fill: "none",
      stroke: "rgb(50,108,152)",
      strokeWidth: "119.01px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3483.55,475.645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1303.29,6667.31C1261.28,6662.99 1206.23,6619.31 1209.14,6537.35C1211.81,6462.42 1295.36,6405.51 1367.83,6405.87C1442.7,6406.25 1518.63,6468.67 1521.45,6544.45C1522.82,6581.36 1507.89,6618.09 1482.99,6641.88C1469.24,6655.01 1452.45,6664.2 1433.68,6667.31L1433.68,7021.65",
    style: {
      fill: "none",
      stroke: "rgb(50,108,152)",
      strokeWidth: "119.01px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3483.55,475.645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1433.68,7021.65L1703.59,7021.65L1703.59,6333.77C1662.83,6331.62 1626.36,6296.59 1623.41,6240.98C1619.62,6169.61 1681.61,6116.03 1767.62,6115.8C1849.33,6115.58 1901.53,6172.51 1902.92,6232.01C1904.26,6289.38 1865.35,6328.5 1826.01,6330.49L1828.81,7021.65",
    style: {
      fill: "none",
      stroke: "rgb(50,108,152)",
      strokeWidth: "119.01px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3483.55,475.645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1871.73,7021.65L1828.81,7021.65",
    style: {
      fill: "none",
      stroke: "rgb(50,108,152)",
      strokeWidth: "119.01px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.734415,3498.65,2340.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1832.39,7021.65L2103.37,7021.65C2148.35,6924.83 2238.1,6883.25 2306.17,6880.62C2414.9,6876.42 2511.08,6984.8 2508.32,7159.87C2506.78,7257.71 2454.44,7418.92 2279.29,7427.04L1008.52,7427.04",
    style: {
      fill: "none",
      stroke: "rgb(50,108,152)",
      strokeWidth: "135.65px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-974.069,5805.71)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1541.67,0,0,1541.67,4375.84,8435.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.208,-0L0.208,-0.238L0.378,-0.238C0.522,-0.238 0.602,-0.336 0.602,-0.452C0.602,-0.569 0.523,-0.667 0.378,-0.667L0.066,-0.667L0.066,-0L0.208,-0ZM0.358,-0.363L0.208,-0.363L0.208,-0.542L0.358,-0.542C0.414,-0.542 0.457,-0.508 0.457,-0.452C0.457,-0.397 0.414,-0.363 0.358,-0.363Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1541.67,0,0,1541.67,5339.38,8435.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.607,-0L0.456,-0.254C0.528,-0.271 0.603,-0.335 0.603,-0.452C0.603,-0.576 0.517,-0.667 0.378,-0.667L0.066,-0.667L0.066,-0L0.208,-0L0.208,-0.237L0.312,-0.237L0.443,-0L0.607,-0ZM0.358,-0.362L0.208,-0.362L0.208,-0.542L0.358,-0.542C0.414,-0.542 0.457,-0.508 0.457,-0.453C0.457,-0.396 0.414,-0.362 0.358,-0.362Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1541.67,0,0,1541.67,6330.67,8435.56)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.066,
    y: -0.667,
    width: 0.142,
    height: 0.667,
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(625,0,0,625,6753.09,8435.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.261,0.196C0.38,0.196 0.522,0.151 0.522,-0.032L0.522,-0.483L0.395,-0.483L0.395,-0.421C0.356,-0.471 0.303,-0.495 0.245,-0.495C0.123,-0.495 0.032,-0.407 0.032,-0.249C0.032,-0.088 0.125,-0.004 0.245,-0.004C0.305,-0.004 0.357,-0.031 0.395,-0.079L0.395,-0.032C0.395,0.066 0.322,0.092 0.261,0.092C0.201,0.092 0.149,0.075 0.11,0.033L0.053,0.124C0.114,0.177 0.179,0.196 0.261,0.196ZM0.286,-0.116C0.213,-0.116 0.163,-0.166 0.163,-0.249C0.163,-0.332 0.213,-0.382 0.286,-0.382C0.327,-0.382 0.373,-0.359 0.395,-0.328L0.395,-0.171C0.373,-0.14 0.327,-0.116 0.286,-0.116Z",
    style: {
      fill: "rgb(50,108,152)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(625,0,0,625,7118.71,8435.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.516,-0L0.516,-0.483L0.389,-0.483L0.389,-0.156C0.367,-0.128 0.328,-0.101 0.279,-0.101C0.225,-0.101 0.19,-0.123 0.19,-0.19L0.19,-0.483L0.063,-0.483L0.063,-0.14C0.063,-0.046 0.113,0.012 0.219,0.012C0.298,0.012 0.356,-0.025 0.389,-0.061L0.389,-0L0.516,-0Z",
    style: {
      fill: "rgb(50,108,152)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(625,0,0,625,7480.59,8435.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.126,-0.535C0.168,-0.535 0.202,-0.569 0.202,-0.611C0.202,-0.653 0.168,-0.686 0.126,-0.686C0.085,-0.686 0.051,-0.653 0.051,-0.611C0.051,-0.569 0.085,-0.535 0.126,-0.535ZM0.19,-0L0.19,-0.483L0.063,-0.483L0.063,-0L0.19,-0Z",
    style: {
      fill: "rgb(50,108,152)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(625,0,0,625,7638.71,8435.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.523,-0L0.523,-0.667L0.395,-0.667L0.395,-0.421C0.357,-0.471 0.303,-0.495 0.246,-0.495C0.123,-0.495 0.032,-0.399 0.032,-0.242C0.032,-0.08 0.125,0.012 0.246,0.012C0.305,0.012 0.357,-0.014 0.395,-0.062L0.395,-0L0.523,-0ZM0.286,-0.101C0.213,-0.101 0.163,-0.158 0.163,-0.242C0.163,-0.325 0.213,-0.382 0.286,-0.382C0.328,-0.382 0.374,-0.359 0.395,-0.327L0.395,-0.156C0.374,-0.124 0.328,-0.101 0.286,-0.101Z",
    style: {
      fill: "rgb(50,108,152)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(625,0,0,625,8004.96,8435.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.29,0.012C0.365,0.012 0.441,-0.011 0.489,-0.055L0.432,-0.139C0.401,-0.109 0.345,-0.092 0.304,-0.092C0.222,-0.092 0.174,-0.141 0.165,-0.2L0.524,-0.2L0.524,-0.23C0.524,-0.387 0.427,-0.495 0.282,-0.495C0.136,-0.495 0.032,-0.382 0.032,-0.242C0.032,-0.087 0.143,0.012 0.29,0.012ZM0.402,-0.288L0.164,-0.288C0.169,-0.336 0.203,-0.391 0.282,-0.391C0.366,-0.391 0.398,-0.334 0.402,-0.288Z",
    style: {
      fill: "rgb(50,108,152)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(625,0,0,625,8511.21,8435.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.607,-0L0.456,-0.254C0.528,-0.271 0.603,-0.335 0.603,-0.452C0.603,-0.576 0.517,-0.667 0.378,-0.667L0.066,-0.667L0.066,-0L0.208,-0L0.208,-0.237L0.312,-0.237L0.443,-0L0.607,-0ZM0.358,-0.362L0.208,-0.362L0.208,-0.542L0.358,-0.542C0.414,-0.542 0.457,-0.508 0.457,-0.453C0.457,-0.396 0.414,-0.362 0.358,-0.362Z",
    style: {
      fill: "rgb(50,108,152)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(625,0,0,625,8913.09,8435.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.663,-0L0.663,-0.667L0.521,-0.667L0.521,-0.248L0.212,-0.667L0.066,-0.667L0.066,-0L0.208,-0L0.208,-0.435L0.526,-0L0.663,-0Z",
    style: {
      fill: "rgb(50,108,152)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(625,0,0,625,9368.71,8435.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.688,-0L0.431,-0.667L0.253,-0.667L-0.004,-0L0.157,-0L0.199,-0.113L0.485,-0.113L0.527,-0L0.688,-0ZM0.446,-0.238L0.238,-0.238L0.342,-0.525L0.446,-0.238Z",
    style: {
      fill: "rgb(50,108,152)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(625,0,0,625,9956.84,8435.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.339,0.012C0.463,0.012 0.553,-0.081 0.553,-0.242C0.553,-0.403 0.463,-0.495 0.339,-0.495C0.28,-0.495 0.227,-0.469 0.19,-0.422L0.19,-0.483L0.063,-0.483L0.063,0.184L0.19,0.184L0.19,-0.062C0.23,-0.012 0.282,0.012 0.339,0.012ZM0.299,-0.101C0.258,-0.101 0.211,-0.126 0.19,-0.157L0.19,-0.327C0.212,-0.359 0.258,-0.382 0.299,-0.382C0.372,-0.382 0.422,-0.325 0.422,-0.242C0.422,-0.158 0.372,-0.101 0.299,-0.101Z",
    style: {
      fill: "rgb(50,108,152)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(625,0,0,625,10321.2,8435.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.19,-0L0.19,-0.319C0.211,-0.35 0.267,-0.374 0.309,-0.374C0.324,-0.374 0.335,-0.373 0.344,-0.371L0.344,-0.495C0.284,-0.495 0.225,-0.46 0.19,-0.418L0.19,-0.483L0.063,-0.483L0.063,-0L0.19,-0Z",
    style: {
      fill: "rgb(50,108,152)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(625,0,0,625,10546.2,8435.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.29,0.012C0.365,0.012 0.441,-0.011 0.489,-0.055L0.432,-0.139C0.401,-0.109 0.345,-0.092 0.304,-0.092C0.222,-0.092 0.174,-0.141 0.165,-0.2L0.524,-0.2L0.524,-0.23C0.524,-0.387 0.427,-0.495 0.282,-0.495C0.136,-0.495 0.032,-0.382 0.032,-0.242C0.032,-0.087 0.143,0.012 0.29,0.012ZM0.402,-0.288L0.164,-0.288C0.169,-0.336 0.203,-0.391 0.282,-0.391C0.366,-0.391 0.398,-0.334 0.402,-0.288Z",
    style: {
      fill: "rgb(50,108,152)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1541.67,0,0,1541.67,10891.8,8435.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.33,-0C0.538,-0 0.683,-0.132 0.683,-0.334C0.683,-0.534 0.538,-0.667 0.329,-0.667L0.066,-0.667L0.066,-0L0.33,-0ZM0.329,-0.125L0.208,-0.125L0.208,-0.542L0.33,-0.542C0.466,-0.542 0.538,-0.451 0.538,-0.334C0.538,-0.22 0.461,-0.125 0.329,-0.125Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1541.67,0,0,1541.67,11998.8,8435.56)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.066,
    y: -0.667,
    width: 0.142,
    height: 0.667,
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1541.67,0,0,1541.67,12421.2,8435.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.39,0.012C0.536,0.012 0.621,-0.069 0.668,-0.152L0.546,-0.211C0.518,-0.157 0.458,-0.114 0.39,-0.114C0.268,-0.114 0.18,-0.207 0.18,-0.333C0.18,-0.459 0.268,-0.552 0.39,-0.552C0.458,-0.552 0.518,-0.509 0.546,-0.455L0.668,-0.515C0.621,-0.599 0.536,-0.678 0.39,-0.678C0.189,-0.678 0.034,-0.539 0.034,-0.333C0.034,-0.128 0.189,0.012 0.39,0.012Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1541.67,0,0,1541.67,13480.3,8435.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.363,-0L0.363,-0.542L0.557,-0.542L0.557,-0.667L0.025,-0.667L0.025,-0.542L0.22,-0.542L0.22,-0L0.363,-0Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(600,0,0,600,14377.5,8435.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.128,0.011C0.172,0.011 0.209,-0.026 0.209,-0.07C0.209,-0.114 0.172,-0.151 0.128,-0.151C0.084,-0.151 0.047,-0.114 0.047,-0.07C0.047,-0.026 0.084,0.011 0.128,0.011Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(600,0,0,600,14531.7,8435.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.126,-0.535C0.168,-0.535 0.202,-0.569 0.202,-0.611C0.202,-0.653 0.168,-0.686 0.126,-0.686C0.085,-0.686 0.051,-0.653 0.051,-0.611C0.051,-0.569 0.085,-0.535 0.126,-0.535ZM0.19,-0L0.19,-0.483L0.063,-0.483L0.063,-0L0.19,-0Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(600,0,0,600,14683.5,8435.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.225,0.012C0.278,0.012 0.312,-0.002 0.331,-0.019L0.304,-0.116C0.297,-0.108 0.279,-0.101 0.26,-0.101C0.232,-0.101 0.216,-0.124 0.216,-0.155L0.216,-0.372L0.314,-0.372L0.314,-0.483L0.216,-0.483L0.216,-0.615L0.089,-0.615L0.089,-0.483L0.009,-0.483L0.009,-0.372L0.089,-0.372L0.089,-0.121C0.089,-0.034 0.136,0.012 0.225,0.012Z",
    style: {
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1409.9,5756.42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(625,0,0,625,4375.84,7824.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.79,-0L0.79,-0.349C0.79,-0.448 0.737,-0.495 0.648,-0.495C0.574,-0.495 0.51,-0.451 0.482,-0.408C0.465,-0.462 0.419,-0.495 0.348,-0.495C0.274,-0.495 0.211,-0.449 0.19,-0.421L0.19,-0.483L0.063,-0.483L0.063,-0L0.19,-0L0.19,-0.326C0.209,-0.352 0.246,-0.382 0.29,-0.382C0.342,-0.382 0.362,-0.35 0.362,-0.305L0.362,-0L0.49,-0L0.49,-0.326C0.508,-0.352 0.545,-0.382 0.59,-0.382C0.642,-0.382 0.662,-0.35 0.662,-0.305L0.662,-0L0.79,-0Z",
    style: {
      fill: "rgb(50,108,152)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(625,0,0,625,4908.96,7824.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.29,0.012C0.365,0.012 0.441,-0.011 0.489,-0.055L0.432,-0.139C0.401,-0.109 0.345,-0.092 0.304,-0.092C0.222,-0.092 0.174,-0.141 0.165,-0.2L0.524,-0.2L0.524,-0.23C0.524,-0.387 0.427,-0.495 0.282,-0.495C0.136,-0.495 0.032,-0.382 0.032,-0.242C0.032,-0.087 0.143,0.012 0.29,0.012ZM0.402,-0.288L0.164,-0.288C0.169,-0.336 0.203,-0.391 0.282,-0.391C0.366,-0.391 0.398,-0.334 0.402,-0.288Z",
    style: {
      fill: "rgb(50,108,152)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(625,0,0,625,5415.21,7824.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.29,0.012C0.365,0.012 0.441,-0.011 0.489,-0.055L0.432,-0.139C0.401,-0.109 0.345,-0.092 0.304,-0.092C0.222,-0.092 0.174,-0.141 0.165,-0.2L0.524,-0.2L0.524,-0.23C0.524,-0.387 0.427,-0.495 0.282,-0.495C0.136,-0.495 0.032,-0.382 0.032,-0.242C0.032,-0.087 0.143,0.012 0.29,0.012ZM0.402,-0.288L0.164,-0.288C0.169,-0.336 0.203,-0.391 0.282,-0.391C0.366,-0.391 0.398,-0.334 0.402,-0.288Z",
    style: {
      fill: "rgb(50,108,152)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(625,0,0,625,5760.84,7824.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.523,-0L0.523,-0.667L0.395,-0.667L0.395,-0.421C0.357,-0.471 0.303,-0.495 0.246,-0.495C0.123,-0.495 0.032,-0.399 0.032,-0.242C0.032,-0.08 0.125,0.012 0.246,0.012C0.305,0.012 0.357,-0.014 0.395,-0.062L0.395,-0L0.523,-0ZM0.286,-0.101C0.213,-0.101 0.163,-0.158 0.163,-0.242C0.163,-0.325 0.213,-0.382 0.286,-0.382C0.328,-0.382 0.374,-0.359 0.395,-0.327L0.395,-0.156C0.374,-0.124 0.328,-0.101 0.286,-0.101Z",
    style: {
      fill: "rgb(50,108,152)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(625,0,0,625,6127.09,7824.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.126,-0.535C0.168,-0.535 0.202,-0.569 0.202,-0.611C0.202,-0.653 0.168,-0.686 0.126,-0.686C0.085,-0.686 0.051,-0.653 0.051,-0.611C0.051,-0.569 0.085,-0.535 0.126,-0.535ZM0.19,-0L0.19,-0.483L0.063,-0.483L0.063,-0L0.19,-0Z",
    style: {
      fill: "rgb(50,108,152)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(625,0,0,625,6285.21,7824.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.225,0.012C0.278,0.012 0.312,-0.002 0.331,-0.019L0.304,-0.116C0.297,-0.108 0.279,-0.101 0.26,-0.101C0.232,-0.101 0.216,-0.124 0.216,-0.155L0.216,-0.372L0.314,-0.372L0.314,-0.483L0.216,-0.483L0.216,-0.615L0.089,-0.615L0.089,-0.483L0.009,-0.483L0.009,-0.372L0.089,-0.372L0.089,-0.121C0.089,-0.034 0.136,0.012 0.225,0.012Z",
    style: {
      fill: "rgb(50,108,152)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(625,0,0,625,6496.46,7824.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.126,-0.535C0.168,-0.535 0.202,-0.569 0.202,-0.611C0.202,-0.653 0.168,-0.686 0.126,-0.686C0.085,-0.686 0.051,-0.653 0.051,-0.611C0.051,-0.569 0.085,-0.535 0.126,-0.535ZM0.19,-0L0.19,-0.483L0.063,-0.483L0.063,-0L0.19,-0Z",
    style: {
      fill: "rgb(50,108,152)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(625,0,0,625,6654.59,7824.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.517,-0L0.517,-0.341C0.517,-0.435 0.466,-0.495 0.359,-0.495C0.281,-0.495 0.221,-0.457 0.19,-0.421L0.19,-0.483L0.063,-0.483L0.063,-0L0.19,-0L0.19,-0.326C0.212,-0.354 0.25,-0.382 0.3,-0.382C0.354,-0.382 0.389,-0.359 0.389,-0.292L0.389,-0L0.517,-0Z",
    style: {
      fill: "rgb(50,108,152)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(625,0,0,625,7016.46,7824.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.261,0.196C0.38,0.196 0.522,0.151 0.522,-0.032L0.522,-0.483L0.395,-0.483L0.395,-0.421C0.356,-0.471 0.303,-0.495 0.245,-0.495C0.123,-0.495 0.032,-0.407 0.032,-0.249C0.032,-0.088 0.125,-0.004 0.245,-0.004C0.305,-0.004 0.357,-0.031 0.395,-0.079L0.395,-0.032C0.395,0.066 0.322,0.092 0.261,0.092C0.201,0.092 0.149,0.075 0.11,0.033L0.053,0.124C0.114,0.177 0.179,0.196 0.261,0.196ZM0.286,-0.116C0.213,-0.116 0.163,-0.166 0.163,-0.249C0.163,-0.332 0.213,-0.382 0.286,-0.382C0.327,-0.382 0.373,-0.359 0.395,-0.328L0.395,-0.171C0.373,-0.14 0.327,-0.116 0.286,-0.116Z",
    style: {
      fill: "rgb(50,108,152)",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20210629PridictDesign);
export default __webpack_public_path__ + "static/media/20210629_PRIDICT_Design.615facc4adaa40319ad44a8b64064d3d.svg";
export { ForwardRef as ReactComponent };